import { isNumber } from 'lodash';
import { UndoAction } from './Action';
import DeleteItemAction from './DeleteItemAction';
import ShoppingListItem from '../../../shared/ShoppingListItem';
import { ADD_ITEM } from '../../../graphql/shopping-list';

/* eslint-disable no-underscore-dangle */
let dummyId = 0;
function getDummyId() {
  dummyId -= 1;
  return dummyId;
}

class AddItemAction extends UndoAction {
  constructor(options) {
    super(options);

    this.index = options.index;
    this.item = options.item;
    this.itemListName = options.itemListName || 'unchecked';
  }

  static get name() { return 'AddItemAction'; }

  _executeImpl() {
    // An undo/redo item will have __typename in it, which makes
    // it not a ShoppingListItemInput
    const newItem = new ShoppingListItem(this.item);
    const self = this;

    return this.component.$apollo.mutate({
      mutation: ADD_ITEM,
      variables: {
        id: this.component.shoppingList.id,
        index: this.index,
        item: newItem,
        itemListName: this.itemListName,
      },
      update(store, { data: { shoppingListAddItem } }) {
        self._updateCache(store, shoppingListAddItem);
      },
      optimisticResponse() {
        const shoppingListAddItem = {
          __typename: 'ShoppingListAddItemResult',
          item: Object.assign({}, newItem, { id: getDummyId() }),
          modifiedAt: null,
        };

        shoppingListAddItem.item.__typename = 'ShoppingListItem';
        return { shoppingListAddItem };
      },
    }).then((result) => {
      if (this.item.id) {
        // id already set on this item, which means this action
        // was actually the 'redo' of a previous add, so we need
        // to update any other redo actions on this item with the
        // new id
        this.component.updateUndoRedoItem({
          oldItem: this.item,
          newItem: result.data.shoppingListAddItem.item,
        });
      }

      this.item = result.data.shoppingListAddItem.item;
      return result;
    });
  }

  updateQuery(cachedShoppingList, shoppingListAddItem) {
    if (isNumber(this.index)) {
      cachedShoppingList.items[this.itemListName].splice(this.index, 0, shoppingListAddItem.item);
    } else {
      cachedShoppingList.items[this.itemListName].push(shoppingListAddItem.item);
    }

    return cachedShoppingList;
  }

  undo() {
    return this.component.triggerAction(DeleteItemAction, {
      index: (isNumber(this.index) ? this.index :
        this.component.shoppingList.items[this.itemListName].length - 1),
      itemListName: this.itemListName,
      undoAction: this,
    });
  }

  updateItem(oldItem, newItem) {
    if (this.item.id === oldItem.id) {
      this.item = newItem;
    }
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo add item'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo add item'; }
}

export default AddItemAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/AddItemAction.js